export default "__VITE_ASSET__D_1_QTZj__"